import './home.css';

import galleryItems from '../../data/gallery.json';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import Header from '../Header/Header';

interface GalleryItem {
  id: number;
  name: string;
  path: string;
  image: string;
  title: string;
  description: string;
  link?:string
}

const Home = () => {
  const location = useLocation();
  const selectedCategory = new URLSearchParams(location.search).get('category');
  const items = galleryItems as GalleryItem[];
  
  // Shuffle array function
  const shuffleArray = (array: GalleryItem[]) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };
  
  const filteredItems = selectedCategory
    ? shuffleArray(items.filter((item) => item.name === selectedCategory))
    : shuffleArray(items);

  return (
    <>
      {/* <div className="home-header-wrap"> */}
      <Header />
      {/* </div> */}
      <section id="gallery">
        <div className="image-grid">
          {filteredItems.map((item) => {
            const url = item.image.startsWith('http') 
              ? item.image 
              : `/assets/Images/${item.path}/${item.image}`;

            return (
              <div key={`${item.path}/${item.image}`} style={{
                overflowY:'hidden'
              }}>
                {item?.link ? (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="image-link"
                    aria-label={item.title || item.image}
                    title={item.title || ''}
                  >
                    <img
                      src={url}
                      alt={item.title || item.image}
                      className="photo"
                      decoding="async"
                      width={600}
                      height={400}
                    />
                  </a>
                ) : (
                  <Link
                    to={'/photo/' + item.id}
                    rel="noopener noreferrer"
                    className="image-link"
                    aria-label={item.title || item.image}
                    title={item.title || ''}
                  >
                    <img
                      src={url}
                      alt={item.title || item.image}
                      className="photo"
                      decoding="async"
                      width={600}
                      height={400}
                    />
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default Home;
